var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 296,
    viewBox: "0 0 295 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.941 239.846C218.318 229.078 209.845 179.249 181.017 128.548C152.188 77.8479 113.92 45.4761 95.543 56.2438C77.1657 67.0115 85.6383 116.841 114.467 167.542C143.296 218.242 181.563 250.614 199.941 239.846Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.93 186.891C205.284 187.132 251.704 169.919 251.613 148.445C251.522 126.971 204.954 109.368 147.6 109.128C90.2459 108.887 43.8253 126.1 43.9164 147.574C44.0075 169.048 90.5758 186.651 147.93 186.891Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9573 239.521C114.551 250.466 152.82 218.38 181.434 167.856C210.048 117.331 218.171 67.5004 199.577 56.5556C180.983 45.6108 142.714 77.6964 114.1 128.221C85.4867 178.745 77.3637 228.576 95.9573 239.521Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.742 160.443C147.518 164.433 156.157 162.113 160.037 155.262C163.916 148.411 161.567 139.622 154.79 135.633C148.013 131.643 139.374 133.962 135.495 140.813C131.616 147.665 133.965 156.453 140.742 160.443Z",
    fill: "#FFF4D9",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramAtom1);
export default __webpack_public_path__ + "static/media/program-atom-1.ca827646cb38226906aa22ed25376e28.svg";
export { ForwardRef as ReactComponent };